import { createFileRoute } from "@tanstack/react-router";
import BokforingStockholm from "@/pages/BokforingStockholm";
import {
  buildBreadcrumbSchema, getBreadcrumbTrail,
  buildPageSchema,
  buildSeoHead,
  buildServiceSchema,
  publicPageSeo,
} from "@/data/seo";

export const Route = createFileRoute("/bokforing-stockholm")({
  head: () =>
    buildSeoHead(
      publicPageSeo.bokforingStockholm,
      [
        buildPageSchema(publicPageSeo.bokforingStockholm, "WebPage"),
        buildServiceSchema(publicPageSeo.bokforingStockholm, "Löpande bokföring i Stockholm", [
          "Digital bokföring",
          "Avstämningar",
          "Rapportering",
          "Proaktiv rådgivning",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/bokforing-stockholm") ?? []),
      ],
    ),
  component: BokforingStockholm,
});
